import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
type Props = {
  className?: string;
  href?: string;
  label?: string;
  bottomImage?: string;
  bottomImageAlt?: string;
};
export default function FollowUsFacebook(t0) {
  const $ = _c(17);
  const {
    className: t1,
    href,
    label: t2,
    bottomImage: t3,
    bottomImageAlt: t4
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const label = t2 === undefined ? "Follow us on Facebook" : t2;
  const bottomImage = t3 === undefined ? "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png" : t3;
  const bottomImageAlt = t4 === undefined ? "Facebook" : t4;
  const t5 = `w-[170px] max-w-full text-white flex items-center justify-center gap-1 px-1 py-2 rounded-full shadow-[inset_0_1px_0_rgba(255,255,255,0.35)] bg-[#3B5998] ${className}`;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" /></svg>;
    $[0] = t6;
  } else {
    t6 = $[0];
  }
  let t7;
  if ($[1] !== label) {
    t7 = <span className="text-12-english-500 text-FFFFFF leading-none font-medium select-none">{label}</span>;
    $[1] = label;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  let t8;
  if ($[3] !== label || $[4] !== t5 || $[5] !== t7) {
    t8 = <div className={t5} role="button" aria-label={label}>{t6}{t7}</div>;
    $[3] = label;
    $[4] = t5;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== bottomImage || $[8] !== bottomImageAlt) {
    t9 = bottomImage && <div className="mt-2"><Image src={bottomImage} alt={bottomImageAlt} width={250} height={250} className="object-contain" /></div>;
    $[7] = bottomImage;
    $[8] = bottomImageAlt;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t8 || $[11] !== t9) {
    t10 = <div className="flex flex-col items-center gap-3 p-4">{t8}{t9}</div>;
    $[10] = t8;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const buttonContent = t10;
  if (href) {
    let t11;
    if ($[13] !== buttonContent || $[14] !== href || $[15] !== label) {
      t11 = <a href={href} aria-label={label} className="inline-block w-full" target="_blank" rel="noopener noreferrer">{buttonContent}</a>;
      $[13] = buttonContent;
      $[14] = href;
      $[15] = label;
      $[16] = t11;
    } else {
      t11 = $[16];
    }
    return t11;
  }
  return buttonContent;
}